import { useQuery } from "@tanstack/react-query";
import { makeApiRequest } from "../../utils";

export const useFetchProducts = ({
  page = 1,
  pageSize = 20,
  brandId,
  name,
  sortField = "createdAt",
  sortOrder = "desc"
} = {}) => {
  const queryParams = new URLSearchParams({
    page: page.toString(),
    pageSize: pageSize.toString(),
    sortField,
    sortOrder
  });

  if (brandId) {
    queryParams.append("brandId", brandId.toString());
  }

  if (name) {
    queryParams.append("name", name);
  }

  return useQuery({
    queryKey: ["products", page, pageSize, brandId, name, sortField, sortOrder],
    queryFn: async () => {
      const response = await makeApiRequest({
        endpoint: `/api/products?${queryParams.toString()}`,
        method: "GET"
      });
      return response;
    },
    keepPreviousData: true,
    staleTime: 30000
  });
};
